<template>
  <div class="cv-chrono">
    <!-- 2023-present -->
    <CvChunk 
      yearRange="June 2023 - Present" 
      jobColumnHeader="Taskize" 
      jobColumnSubHead="Senior Software Engineer"
      >
      <div slot="jobContent">
        <p>At Taskize I work on our APIs and Integrations team helping build efficient, scalable and functional APIs and integrations with third party platforms.</p>
        <p>As well as working on our backend API infrastructure to improve performance and scalability I am also a key part of our AI Taskforce, building and prototyping practical AI solutions for our customers.</p>
        
      </div>
    </CvChunk>
    
    <!-- 2023-2023 -->
    <CvChunk 
      yearRange="May 2023 - June 2023" 
      jobColumnHeader="😎🌞 Spring Break 🌞😎" 
      jobColumnSubHead="Relax and Refocus"
      >
      <div slot="jobContent">
        <p>I am taking some time to relax first and foremost, then looking for exciting and engaging new work in climate tech, government, finance, funded PhDs or anything that piques my interest.</p>
        <p>If you'd like to chat about potential opportunities that might match this then check out my <a href="./assets/Lewis A Mckeown CV.pdf" target="_blank" title="Lewis A Mckeown CV - A professional PDF CV, so fancy">CV </a> and feel free to <a title="Opens your email client" href="mailto:lewisamckeown@gmail.com?subject=Spring%20break%20website%20contact&amp;body=How%20are%20you">get in touch</a>.</p>
      </div>
    </CvChunk>

    <!-- 2021-2023 -->
    <CvChunk 
      yearRange="2021 - April 2023" 
      jobColumnHeader="Fivium" 
      jobColumnSubHead="Senior Developer"
      >
      <div slot="jobContent">
        <p>At Fivium I help push for the appropriate use of applied machine learning in our products and services. I have worked on several research projects which use natural language processing to improve our existing products and given Dev talks about the process.</p>
        <p>One of these research projects has been developed and deployed as a production system helping improve user experience and data security.</p> 
        <p>I have also worked on replacing a legacy search system with an elasticsearch implementation to greatly reduce database load and massively improve search performance and capabilities.</p>
      </div>
    </CvChunk>


    <!-- 2019-2020 -->
    <CvChunk 
      yearRange="2019 - 2021" 
      jobColumnHeader="Fivium" 
      jobColumnSubHead="Developer"
      academiaColumnHeader="Some Other Stuff"
      academiaColumnSubHead="Odd Bits I've Been Up to"
      >
      <div slot="jobContent">
        <p>Currently some of my most exciting work is bringing applied machine learning to projects at Fivium.</p> 
        <p>To this end I have completed two research projects based on using natural language processing to enhance Fivium's existing products and improve customer experience.</p>
        <p>I am also actively developing applications using Spring Boot, Vue.js and Play.</p> 
      </div>
      <div slot="academiaContent">
        <p>I've been working on <a href="assets/P5Sketches/index.html" target="_blank">re-creating my favourite art works</a> in <a href="https://p5js.org" target="_blank">p5.js</a> and <router-link to="/dnd">generating DND characters</router-link> with machine learning.</p>
        <p>I have also been re-writing this site in <a href="https://vuejs.org/" target="_blank">Vue.js</a> (it aint pretty but I learned a lot doing it).</p>
      </div> 
    </CvChunk>

    <!-- 2018 - 2019 -->
  <CvChunk 
      yearRange="2018 - 2019" 
      jobColumnHeader="Fivium" 
      jobColumnSubHead="Developer"
      academiaColumnHeader="ICCC '18"
      academiaColumnSubHead="Paper Accepted to Conference"
      >
      <div slot="jobContent">
        <p>Worked with a small, agile development team to produce the Adoption Support Fund application at Fivium.</p> 
      </div>
      <div slot="academiaContent">
          <p>I presented <a href="http://computationalcreativity.net/iccc2018/sites/default/files/iccc_proc18.pdf" target="_blank">a paper</a> based on <router-link to="/thesis">my dissertation</router-link> at <a href="http://computationalcreativity.net/iccc2018/" target="_blank">the 9th International Conference on Computational Creativity in Salamanca, Spain in 2018</a>.</p>
         <p>The presentation took the form of a <a href="assets/LM ICCC18 Slides.pdf" target="_blank">short talk</a> and <a href="assets/Lewis Mckeown Anna Jordanous ICCC18 Poster.pdf" target="_blank">poster presentation</a>.</p>
      </div>
    </CvChunk>
    
    <!-- 2016-2017 -->
    <CvChunk 
      yearRange="2014 - 2017" 
      academiaColumnHeader="Fivium" 
      academiaColumnSubHead="Placement Student"
      jobColumnHeader="University of Kent"
      jobColumnSubHead="Master's Degree, Computer Science with Industrial Placement"
      >
      <div slot="academiaContent">
         <p>I completed a year long industrial placement at Fivium working on applications for BEIS, the Marine Management Organisation and DIT. During my placement year I was an active participant in calls and meetings with key stakeholders to undertake requirements gathering and helped deliver software which solved complex customer needs.</p>
          <p>At Fivium I got the opportunity to learn and work with tools such as FOXopen, Oracle SQL and PL/SQL (including completing the Oracle 12c SQL fundamentals certification, 1Z0-061), the Play framework, Python and many more.</p>
      </div>
      <div slot="jobContent">
        <p>My <router-link to="/thesis">MSc dissertation</router-link> focused on computational creativity, specifically on narrative generation and the impact constraints have on the creativity of narrative generating software.</p> 
        <p>My work was awarded the School of Computing Prize for Outstanding Performance for my graduating year.</p>
      </div>
    </CvChunk>
    
  </div>
</template>

<script>
import CvChunk from './CvChunk.vue'

export default {
  name: 'CvChrono',
  components: {
    CvChunk
  },
  data() { 
    return { 
        readwiseKey: process.env.VUE_APP_READWISE_API_KEY,
    }
}
}
</script>
